module.exports = require("@azure/functions-extensions-base");